// extracted by mini-css-extract-plugin
export var TextColor = "essence-module--TextColor--KIB4X";
export var centeredarrow = "essence-module--centeredarrow--OqKuv";
export var fontSize = "essence-module--fontSize--6oX68";